module.exports = __webpack_public_path__ + "static/media/workAntihumidity5.89433834.jpg";